import { Platform } from 'react-native'

export const FONT_FAMILY_BASE = 'NunitoSans_400Regular'
export const FONT_FAMILY_BOLD = 'NunitoSans_700Bold'
export const FONT_FAMILY_SPECIAL = 'Montserrat_400Regular'
export const FONT_FAMILY_SPECIAL_BOLD = 'Montserrat_700Bold'

export const FONT_SIZE_XSMALL = 12
export const FONT_SIZE_SMALL = 13
export const FONT_SIZE_BASE = 18
export const FONT_SIZE_MEDIUM = 22
export const FONT_SIZE_LARGE = 24
export const FONT_SIZE_HEADER = 18

export const FONT_SIZE_H1 = FONT_SIZE_LARGE
export const FONT_SIZE_H2 = FONT_SIZE_MEDIUM
export const FONT_SIZE_H3 = FONT_SIZE_BASE
export const FONT_SIZE_H4 = FONT_SIZE_SMALL
// export const FONT_SIZE_H5 = FONT_SIZE_MEDIUM
// export const FONT_SIZE_H6 = FONT_SIZE_MEDIUM

export const BORDER_RADIUS_SMALL = 5
export const BORDER_RADIUS_DEFAULT = 12

export const INPUT_HEIGHT_BASE = 50

export const SPACE_XS = 4
export const SPACE_SM = 10
export const SPACE_MD = 20
export const SPACE_LG = 40
